const visible = ref(false);
const title = ref("");
const defaultValue = ref("")
const password = ref(false);

let localResolve: (value: string | PromiseLike<string>) => void

type R3InputBoxParams = {
	title: string,
	defaultValue?: string,
	password?: boolean
}
export const useR3Inputbox = () => {

	const R3InputBox = (params: R3InputBoxParams): Promise<string> => {

		title.value = params.title;
		if (params.defaultValue) defaultValue.value = params.defaultValue;
		if (params.password) password.value = params.password
		visible.value = true;

		return new Promise(resolve => { localResolve = resolve })
	}

	const handleResponse = (value: string) => {
		localResolve(value);
		visible.value = false;

	}

	return {
		visible,
		title,
		defaultValue,
		password,
		R3InputBox,
		handleResponse
	}
}